import { IonContent } from "@ionic/react";

import { BackToolbarComponent } from "@/components/toolbar/back-toolbar";
import StepToolbarComponent from "@/components/toolbar/step-toolbar";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { useSafeAreaStyles } from "@/hooks/utils/use-safe-area-styles";
import { cn } from "@/utils/cn";
import { IonPage } from "@ionic/react";
import { memo, ReactNode, RefObject } from "react";

interface OnboardingPageContainerProps {
  pageRef?: RefObject<HTMLElement | null>;
  children: ReactNode;
  className?: string;
  showToolbar?: boolean;
  actionButton?: React.ReactNode;
  title?: string;
  backgroundColorClassName?: string;
  color?: string;
}

export const OnboardingPageContainer = memo(function OnboardingPageContainer({
  children,
  className,
  showToolbar = true,
  actionButton,
  pageRef,
  title,
  backgroundColorClassName,
  color = "white",
}: OnboardingPageContainerProps) {
  const safeAreaStyles = useSafeAreaStyles();
  const { info, totalSteps } = useStepRouteInfo();

  const getToolbar = () => {
    if (!showToolbar) return null;
    if (info?.step) {
      return (
        <StepToolbarComponent
          totalStep={totalSteps}
          progress={info?.step ? info.step / totalSteps : 0}
        />
      );
    }
    return <BackToolbarComponent isStepRoute title={title} actionButton={actionButton} />;
  };
  return (
    <IonPage
      ref={pageRef}
      className={backgroundColorClassName}
      color={color}
      style={{ ...safeAreaStyles }}
    >
      {getToolbar()}
      <IonContent
        fullscreen
        className={backgroundColorClassName}
        color={color}
        style={{
          ...safeAreaStyles,
          backgroundColor: color,
        }}
      >
        <div
          className={cn(
            "mx-auto flex h-full w-full max-w-[450px] flex-col items-center justify-start gap-4 self-center overflow-hidden",
            className,
          )}
        >
          {children}
        </div>
      </IonContent>
    </IonPage>
  );
});
